import { get, patch } from './client.js';

export const orgPoliciesApi = {
  get: (orgId) => get(`/orgs/${orgId}/policies`),
  update: (orgId, data) => patch(`/orgs/${orgId}/policies`, data),
};
